import $ from "jquery";

const floatingButton = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    $(function () {
      const el = {
        buttonCart: ".Cart__Main .cart-collaterals .wc-proceed-to-checkout",
        stopPoint: ".Cart__Main .cart-collaterals .order-total",
      };

      const windowWidth = $(window).width();

      if (windowWidth > 600) return;
      if ($(el.buttonCart).length === 0) return;

      $.fn.isInViewport = function () {
        let elementTop = $(this).offset().top;

        let viewportTop = $(window).scrollTop();

        let viewportHalf = viewportTop + $(window).height();

        return elementTop < viewportHalf;
      };

      $(window).on("load resize scroll", function () {
        if ($(el.stopPoint).isInViewport()) {
          $(el.buttonCart).addClass("offset");
        } else {
          $(el.buttonCart).removeClass("offset");
        }
      });
    });
  };

  init();
};

try {
  floatingButton();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error("floatingButton :" + error);
}
